// extracted by mini-css-extract-plugin
module.exports = {"button":"BtnCommentaire_button__28UaU","hasValue":"BtnCommentaire_hasValue__2a_U7","picto":"BtnCommentaire_picto__30dr6"};